export default __webpack_public_path__ + "static/media/top-banner.68bb9f68.jpg";